import { IDocumentLibraryService } from "../../documents"
import { IFieldsMapFactory } from "../../fields/map"
import { DialogHeader } from "../../react/DialogHeader"
import { IOmniaSession } from "../../types"
import { createEmptyState, createInitialState, DoclibState } from "../state"
import { IDocumentLibraryArguments } from "../types"
import { DocumentLibrary } from "./documentLibrary/DocumentLibrary"

interface Props {
    svc: IDocumentLibraryService
    session: IOmniaSession
    args?: IDocumentLibraryArguments,
    mapFactory?: IFieldsMapFactory,
    close: (result?: any) => void
}

export function DocumentLibraryPopup({ svc, mapFactory, session, args, close }: Props) {

    const [state, setState] = React.useState<DoclibState>(undefined)

    React.useEffect(() => {

        if (!state) {

            createInitialState(
                createEmptyState(svc, session, args)
            ).then(setState)

        }


    }, [state])

    if (!state) {
        return null
    }

    function commit() {

        const selectedDocuments = getSelectedDocuments()
            .map(d => d.document)

        if (selectedDocuments.length) {
            close(selectedDocuments)
        }

    }

    function getSelectedDocuments() {

        const { documents } = state;

        return documents?.filter(
            d => d.selected)

    }

    const canCommit = getSelectedDocuments()?.length > 0;



    return <div className="omnia-document-library-popup">

        <DialogHeader>
            Document library
        </DialogHeader>

        <div className="modal-body">
            <DocumentLibrary {...{ state, setState, mapFactory }}>
            </DocumentLibrary>
        </div>

        <div className="modal-footer">

            <button type="button" className="btn btn-warning" onClick={close}>
                {state.documentSelection ? 'Cancel' : 'Close'}
            </button>
            {" "}
            {state.documentSelection &&
                <button type="button"
                    className="btn btn-success"
                    disabled={!canCommit}
                    onClick={commit}>
                    Confirm
                </button>
            }


        </div>

    </div >

}
